import { Box, Divider, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import useAppShellSx from '../../hooks/useAppShellSx';

export default function AppHeaderBrand({ logo, defaultLogo, onLogoClick, variant = 'default' }) {
  const sx = useAppShellSx();
  const { header } = sx;
  const isTest = variant === 'test';
  const titleSx = isTest ? header.brandTitleTest : header.brandTitle;
  const subtitleSx = isTest ? header.brandSubtitleTest : header.brandSubtitle;
  const logoBoxSx = isTest ? header.logoBoxTest : header.logoBox;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: '7px', sm: 2 } , width: {xs:'100%',sm:'auto'}, justifyContent: {xs:'space-evenly',sm:'auto'} }}>
      <Box sx={logoBoxSx}>
        <Box
          component="img"
          src={logo || defaultLogo}
          alt="Organisation logo"
          onClick={onLogoClick}
          sx={{
            cursor: onLogoClick ? 'pointer' : 'default',
            width: '100%',
            height: '100%',
            objectFit: 'contain',
          }}
        />
      </Box>

      {!isTest && (
        <>
          <Divider orientation="vertical" flexItem sx={header.divider} />
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="body1" sx={titleSx}>
              Powered by Machadalo
            </Typography>
            <Typography variant="body2" sx={subtitleSx}>
              Brand owned by Vijaikirti Technologies Pvt. Ltd
            </Typography>
          </Box>
        </>
      )}
    </Box>
  );
}

AppHeaderBrand.propTypes = {
  logo: PropTypes.string,
  defaultLogo: PropTypes.string.isRequired,
  onLogoClick: PropTypes.func,
  variant: PropTypes.oneOf(['default', 'test']),
};
